"use strict";
import { TamaguiProvider as OGTamaguiProvider } from "ui/src";
import config from "ui/src/tamagui.config";
export function TamaguiProvider({ children, ...rest }) {
  return <OGTamaguiProvider config={config} defaultTheme="dark" {...rest}>
      {children}
    </OGTamaguiProvider>;
}
